import React, { PureComponent } from 'react';
import { withStyles, Paper, Table, TableHead, TableBody, TableRow, TableCell, 
  Toolbar, Typography,} from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    maxWidth: 1060,
    margin: 'auto',
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  spacer: {
    flexGrow: 1,
  },
  title: {
    flex: '0 0 auto',
  },
  tablerow: {
    height: 36
  },
});

class PlayersList extends PureComponent {

  componentDidMount() {
    const { userSeason, getPlayersList } = this.props;
    if (userSeason) {
      getPlayersList(userSeason);
    }
  }

  componentDidUpdate(prevProps) {
    const { userSeason, getPlayersList } = this.props;
    if (userSeason !== prevProps.userSeason) {
      getPlayersList(userSeason);
    }
  }

  render() {
    const { fetchingPlayersList, classes } = this.props;

    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div  className={classes.title}>
            <Typography variant="h5">Players Table</Typography>
          </div>
          <div className={classes.spacer} />
        </Toolbar>
        <Table padding="none">
          <TableHead>
            <TableRow>
              <TableCell align="center"><Typography variant="body1">Member ID</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Player</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Guardians</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Division</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Team</Typography></TableCell>
            </TableRow>
          </TableHead>
          {fetchingPlayersList === 'Loaded' && this.renderTableBody()}
        </Table>
      </Paper>
    );
  }

  renderTableBody() {
    const { playersList, classes } = this.props;

    return (
      <TableBody>
        {playersList.filter(player => player.division !== 'Division' || player.team !== 'Team')
          .map((player, index) => {
          return (
            <TableRow className={classes.tablerow} key={`${player.memberId}-${index}`} hover>
              <TableCell align="center"><Typography variant="body2">{player.memberId}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">{player.firstName} {player.lastName}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">
                {player.guardian1Name}
                {(player.guardian2Name !== ' ') ? `, ${(player.guardian2Name)}` : ''}
              </Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">{player.division}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body2">{player.team}</Typography></TableCell>
            </TableRow>
          );
      })}
      </TableBody>
    );
  }

}

PlayersList.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(PlayersList);



// WEBPACK FOOTER //
// ./src/components/PlayersList.js